import {UserRegistrationSource} from "@pg-rp/common-types";

import {oneTapClient} from "../../app/read_rp_environment_variables";
import {googleOneTapAuth} from "./social_auth";

interface IThirdPartyLoginResponse {
    is_new?: boolean;
}

export const googleOneTapLogin = async (params: {
    credential: string;
    onSuccess: (isNewUser: boolean) => Promise<void>;
    onError: (error: unknown) => void;
}): Promise<void> => {
    try {
        const response = (await googleOneTapAuth(
            UserRegistrationSource.REGISTRATION_GOOGLE_ONE_TAP_RP,
            oneTapClient
        )(params.credential)) as IThirdPartyLoginResponse;

        const isNewUser = !!response?.is_new;
        await params.onSuccess(isNewUser);
    } catch (error) {
        params.onError(error);
    }
};
